var AdobeAn;
import 'latest-createjs';

(function (cjs, an) {

    var p; // shortcut to reference prototypes
    var lib = {};
    var ss = {};
    var img = {};
    lib.ssMetadata = [];


// symbols:


    (lib.ariel = function () {
        this.initialize(img.ariel);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0, 0, 485, 546);


    (lib.Bitmap1 = function () {
        this.initialize(img.Bitmap1);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0, 0, 1165, 558);


    (lib.Bitmap2 = function () {
        this.initialize(img.Bitmap2);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0, 0, 2218, 619);


    (lib.img_05 = function () {
        this.initialize(img.img_05);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0, 0, 970, 970);


    (lib.Microphone = function () {
        this.initialize(img.Microphone);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0, 0, 613, 645);// helper functions:

    function mc_symbol_clone() {
        var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
        clone.gotoAndStop(this.currentFrame);
        clone.paused = this.paused;
        clone.framerate = this.framerate;
        return clone;
    }

    function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
        var prototype = cjs.extend(symbol, cjs.MovieClip);
        prototype.clone = mc_symbol_clone;
        prototype.nominalBounds = nominalBounds;
        prototype.frameBounds = frameBounds;
        return prototype;
    }


    (lib.shadov = function (mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics.beginFill('#000000').beginStroke().moveTo(-118.5, 13.1).curveTo(-167.5, 7.7, -167.5, 0).curveTo(-167.5, -7.7, -118.5, -13.1).curveTo(-69.4, -18.5, 0, -18.5).curveTo(69.4, -18.5, 118.4, -13.1).curveTo(167.5, -7.7, 167.5, 0).curveTo(167.5, 7.7, 118.4, 13.1).curveTo(69.4, 18.5, 0, 18.5).curveTo(-69.4, 18.5, -118.5, 13.1).closePath();

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    }).prototype = getMCSymbolPrototype(lib.shadov, new cjs.Rectangle(-167.5, -18.5, 335, 37), null);


    (lib.pattern12_in = function (mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.instance = new lib.Bitmap1();
        this.instance.parent = this;
        this.instance.setTransform(-781, 131);

        this.instance_1 = new lib.Bitmap1();
        this.instance_1.parent = this;
        this.instance_1.setTransform(-582, -279);

        this.timeline.addTween(cjs.Tween.get({}).to({state: [{t: this.instance_1}, {t: this.instance}]}).wait(1));

    }).prototype = getMCSymbolPrototype(lib.pattern12_in, new cjs.Rectangle(-781, -279, 1364, 968), null);


    (lib.pattern3_in = function (mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.instance = new lib.Bitmap2();
        this.instance.parent = this;
        this.instance.setTransform(-1109, -309);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    }).prototype = getMCSymbolPrototype(lib.pattern3_in, new cjs.Rectangle(-1109, -309, 2218, 619), null);


    (lib.pattern_img = function (mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.instance = new lib.img_05();
        this.instance.parent = this;
        this.instance.setTransform(-485, -485);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    }).prototype = getMCSymbolPrototype(lib.pattern_img, new cjs.Rectangle(-485, -485, 970, 970), null);


    (lib.keng = function (mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.instance = new lib.Microphone();
        this.instance.parent = this;
        this.instance.setTransform(-306.5, -322.5);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    }).prototype = getMCSymbolPrototype(lib.keng, new cjs.Rectangle(-306.5, -322.5, 613, 645), null);


    (lib.ariel_1 = function (mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.instance = new lib.ariel();
        this.instance.parent = this;
        this.instance.setTransform(-242.5, -273);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    }).prototype = getMCSymbolPrototype(lib.ariel_1, new cjs.Rectangle(-242.5, -273, 485, 546), null);


    (lib.letter_02_L = function (mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics.beginFill('#FF4F57').beginStroke().moveTo(31.3, 142.9).lineTo(31.3, 103.3).lineTo(57.1, 103.3).lineTo(57.1, 13.1).lineTo(-57.2, 13.1).lineTo(-57.2, 103.3).lineTo(-31, 103.3).lineTo(-31, 142.9).lineTo(-145.9, 142.9).lineTo(-145.9, 103.3).lineTo(-116.8, 103.3).lineTo(-116.8, -103.3).lineTo(-145.9, -103.3).lineTo(-145.9, -142.9).lineTo(-31, -142.9).lineTo(-31, -103.3).lineTo(-57.2, -103.3).lineTo(-57.2, -24.3).lineTo(57.1, -24.3).lineTo(57.1, -103.3).lineTo(31.3, -103.3).lineTo(31.3, -142.9).lineTo(145.8, -142.9).lineTo(145.8, -103.3).lineTo(117, -103.3).lineTo(117, 103.3).lineTo(145.8, 103.3).lineTo(145.8, 142.9).closePath();
        this.shape.setTransform(-0.2, -38.9);

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    }).prototype = getMCSymbolPrototype(lib.letter_02_L, new cjs.Rectangle(-165.5, -210, 331.1, 420), null);


    (lib.pattern12 = function (mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.pt = new lib.pattern12_in();
        this.pt.name = 'pt';
        this.pt.parent = this;

        this.timeline.addTween(cjs.Tween.get(this.pt).wait(1));

    }).prototype = getMCSymbolPrototype(lib.pattern12, new cjs.Rectangle(-781, -279, 1364, 968), null);


    (lib.ptrn3 = function (mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.pt = new lib.pattern3_in();
        this.pt.name = 'pt';
        this.pt.parent = this;
        this.pt.setTransform(0, 0.15);

        this.timeline.addTween(cjs.Tween.get(this.pt).wait(1));

    }).prototype = getMCSymbolPrototype(lib.ptrn3, new cjs.Rectangle(-1109, -308.8, 2218, 619), null);


    (lib.letter = function (mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // letter1
        this.letter1 = new lib.letter_02_L();
        this.letter1.name = 'letter1';
        this.letter1.parent = this;

        this.timeline.addTween(cjs.Tween.get(this.letter1).wait(1));

        // letter2
        this.letter2 = new lib.letter_02_L();
        this.letter2.name = 'letter2';
        this.letter2.parent = this;
        this.letter2.setTransform(0, 0, 0.9, 0.9);
        this.letter2.filters = [new cjs.ColorFilter(0.7, 0.7, 0.7, 1, 0, 0, 0, 0)];
        this.letter2.cache(-167, -212, 335, 424);

        this.timeline.addTween(cjs.Tween.get(this.letter2).wait(1));

        // letter3
        this.letter3 = new lib.letter_02_L();
        this.letter3.name = 'letter3';
        this.letter3.parent = this;
        this.letter3.setTransform(0, 0, 0.8, 0.8);
        this.letter3.filters = [new cjs.ColorFilter(0.51, 0.51, 0.51, 1, 0, 0, 0, 0)];
        this.letter3.cache(-167, -212, 335, 424);

        this.timeline.addTween(cjs.Tween.get(this.letter3).wait(1));

        // letter4
        this.letter4 = new lib.letter_02_L();
        this.letter4.name = 'letter4';
        this.letter4.parent = this;
        this.letter4.setTransform(0, 0, 0.7, 0.7);
        this.letter4.filters = [new cjs.ColorFilter(0.21, 0.21, 0.21, 1, 0, 0, 0, 0)];
        this.letter4.cache(-167, -212, 335, 424);

        this.timeline.addTween(cjs.Tween.get(this.letter4).wait(1));

        // letter5
        this.letter5 = new lib.letter_02_L();
        this.letter5.name = 'letter5';
        this.letter5.parent = this;
        this.letter5.setTransform(0, 0, 0.6, 0.6);
        this.letter5.filters = [new cjs.ColorFilter(0, 0, 0, 1, 0, 0, 0, 0)];
        this.letter5.cache(-167, -212, 335, 424);

        this.timeline.addTween(cjs.Tween.get(this.letter5).wait(1));

    }).prototype = getMCSymbolPrototype(lib.letter, new cjs.Rectangle(-165.5, -210, 331.1, 420), null);


    (lib.mai = function (mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Microphone.png
        this.keng = new lib.keng();
        this.keng.name = 'keng';
        this.keng.parent = this;
        this.keng.setTransform(174.05, -6.6, 0.58, 0.58, 0, 0, 0, 0.1, 0.1);

        this.timeline.addTween(cjs.Tween.get(this.keng).wait(1));

        // Layer_4
        this.shdw = new lib.shadov();
        this.shdw.name = 'shdw';
        this.shdw.parent = this;
        this.shdw.setTransform(174.55, 188.95);
        this.shdw.alpha = 0.1211;

        // this.timeline.addTween(cjs.Tween.get(this.shdw).wait(1));

        // Layer_5 (mask)
        var mask = new cjs.Shape();
        mask._off = true;
        mask.graphics.moveTo(-292.2, 198.7).lineTo(-292.2, -264.2).curveTo(-42, -364.3, 204.2, -204.2).lineTo(204.2, 284.2).lineTo(182.7, 302.7).closePath();
        mask.setTransform(-292.225, -33.1585);

        // Layer_3
        this.ariel = new lib.ariel_1();
        this.ariel.name = 'ariel';
        this.ariel.parent = this;
        this.ariel.setTransform(-333.5, 1);

        var maskedShapeInstanceList = [this.ariel];

        for (var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
            maskedShapeInstanceList[shapedInstanceItr].mask = mask;
        }

        this.timeline.addTween(cjs.Tween.get(this.ariel).wait(1));

        // Layer_2
        this.letter = new lib.letter();
        this.letter.name = 'letter';
        this.letter.parent = this;
        this.letter.setTransform(38.05, 40);

        this.timeline.addTween(cjs.Tween.get(this.letter).wait(1));

        // shapes6 (mask)
        var mask_1 = new cjs.Shape();
        mask_1._off = true;
        mask_1.graphics.moveTo(-114.6, 244.2).curveTo(-138.1, 237.8, -163.8, 225).lineTo(-163.8, 225).curveTo(-182.7, 215.5, -189.9, 196).lineTo(-189.9, 196).curveTo(-194.3, 184.1, -194.3, 168.7).lineTo(-194.3, 168.7).curveTo(-194.3, 153.1, -189.7, 134).lineTo(-189.7, 134).curveTo(-184.6, 112.3, -162.3, 92.3).lineTo(-162.3, 92.3).curveTo(-154.1, 85, -140.7, 75.3).lineTo(-140.7, 75.3).curveTo(-125.1, 64.3, -117.3, 58.5).lineTo(-117.3, 58.5).curveTo(-88.5, 37.5, -75.3, 19).lineTo(-75.3, 19).curveTo(-56.7, -6.8, -56.7, -39.9).lineTo(-56.7, -39.9).curveTo(-56.7, -55.4, -69.7, -72.4).lineTo(-69.7, -72.4).curveTo(-75.9, -80.6, -98.2, -102.9).lineTo(-98.2, -102.9).curveTo(-118.1, -122.8, -126.8, -136.4).lineTo(-126.8, -136.4).curveTo(-139.7, -156.7, -139.7, -177.9).lineTo(-139.7, -177.9).curveTo(-139.7, -183, -137.9, -189.2).lineTo(-137.9, -189.2).curveTo(-135.6, -196.9, -131.1, -203.1).lineTo(-131.1, -203.1).curveTo(-119, -219.9, -95.2, -219.9).lineTo(-95.2, -219.9).curveTo(-89.1, -219.9, -76, -215.2).lineTo(-76, -215.2).lineTo(-49.6, -205).lineTo(-49.6, -205).curveTo(-11.2, -190.6, 12.8, -191.9).lineTo(12.8, -191.9).curveTo(31.7, -192.9, 50.4, -201.8).lineTo(50.4, -201.8).curveTo(63, -207.8, 80.8, -220.5).lineTo(80.8, -220.5).curveTo(101.2, -235.2, 107.5, -238.7).lineTo(107.5, -238.7).curveTo(121.8, -246.9, 133.8, -246.9).lineTo(133.8, -246.9).curveTo(141.2, -246.9, 151.4, -241.5).lineTo(151.4, -241.5).curveTo(161.9, -236, 171.3, -226.9).lineTo(171.3, -226.9).curveTo(194.3, -204.5, 194.3, -177.9).lineTo(194.3, -177.9).curveTo(194.3, -152.1, 174, -133.4).lineTo(174, -133.4).curveTo(165.9, -126, 153.1, -118.2).lineTo(153.1, -118.2).curveTo(146.6, -114.2, 129.3, -104.7).lineTo(129.3, -104.7).curveTo(113.7, -96.2, 105.4, -90.8).lineTo(105.4, -90.8).curveTo(92.8, -82.6, 84.6, -74.3).lineTo(84.6, -74.3).curveTo(64.3, -53.8, 64.3, -24.9).lineTo(64.3, -24.9).curveTo(64.3, -17.3, 69.5, -11.6).lineTo(69.5, -11.6).curveTo(73.9, -6.8, 83.3, -2.3).lineTo(83.3, -2.3).curveTo(88, -0.1, 102.9, 5.8).lineTo(102.9, 5.8).curveTo(116.9, 11.3, 125.3, 15.6).lineTo(125.3, 15.6).curveTo(152.8, 29.5, 167.2, 51.4).lineTo(167.2, 51.4).curveTo(186.3, 80.6, 186.3, 128).lineTo(186.3, 128).curveTo(186.3, 173.8, 165.2, 197.8).lineTo(165.2, 197.8).curveTo(147.7, 217.8, 113, 224.7).lineTo(113, 224.7).curveTo(91.2, 229, 53.7, 229.8).lineTo(53.7, 229.8).curveTo(16.3, 230.7, -3.1, 232.3).lineTo(-3.1, 232.3).curveTo(-22.4, 233.8, -56.7, 242.2).lineTo(-56.7, 242.2).curveTo(-76.2, 246.9, -92.3, 246.9).lineTo(-92.3, 246.9).curveTo(-104.4, 246.9, -114.6, 244.2).closePath();
        mask_1.setTransform(-437.1377, -58.9656);

        // Layer_9
        this.p1 = new lib.pattern_img();
        this.p1.name = 'p1';
        this.p1.parent = this;
        this.p1.setTransform(-322, -17);

        var maskedShapeInstanceList = [this.p1];

        for (var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
            maskedShapeInstanceList[shapedInstanceItr].mask = mask_1;
        }

        this.timeline.addTween(cjs.Tween.get(this.p1).wait(1));

        // shapes7 (mask)
        var mask_2 = new cjs.Shape();
        mask_2._off = true;
        mask_2.graphics.moveTo(-0, -71.6).curveTo(-26.7, -71.7, -45.5, -90.5).curveTo(-64.4, -109.4, -64.4, -136.1).curveTo(-64.4, -162.7, -45.5, -181.6).curveTo(-26.6, -200.4, 0, -200.5).curveTo(26.7, -200.5, 45.5, -181.6).curveTo(64.4, -162.7, 64.4, -136).curveTo(64.4, -109.4, 45.5, -90.5).curveTo(26.7, -71.6, -0, -71.6).lineTo(-0, -71.6).closePath();
        mask_2.setTransform(-3.266, -200.4501);

        // Layer_16
        this.p2 = new lib.ptrn3();
        this.p2.name = 'p2';
        this.p2.parent = this;
        this.p2.setTransform(-24.1, -304.35, 0.11, 1, 47.0003, 0, 0, -0.4, -0.1);

        var maskedShapeInstanceList = [this.p2];

        for (var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
            maskedShapeInstanceList[shapedInstanceItr].mask = mask_2;
        }

        this.timeline.addTween(cjs.Tween.get(this.p2).wait(1));

        // shapes8 (mask)
        var mask_3 = new cjs.Shape();
        mask_3._off = true;
        mask_3.graphics.moveTo(-46.6, 132.8).curveTo(-63.4, 129.1, -104, 84.6).curveTo(-144.7, 40.1, -175.4, 57).curveTo(-206.2, 73.9, -258.5, 45.6).curveTo(-310.9, 17.2, -310.7, -42.6).curveTo(-310.6, -102.5, -216, -59.3).curveTo(-121.4, -16.1, -86.1, -26).curveTo(-50.8, -35.8, -32.1, -32.4).curveTo(-13.5, -28.9, 47.3, -23.8).curveTo(108, -18.6, 63.9, 10.9).curveTo(19.7, 40.4, -5, 88.4).curveTo(-28.1, 133, -44.2, 133).curveTo(-45.4, 133, -46.6, 132.8).closePath();
        mask_3.setTransform(-310.7336, 133.0306);

        // Layer_7
        this.p3 = new lib.pattern12();
        this.p3.name = 'p3';
        this.p3.parent = this;
        this.p3.setTransform(-217.4, 143.95);

        var maskedShapeInstanceList = [this.p3];

        for (var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
            maskedShapeInstanceList[shapedInstanceItr].mask = mask_3;
        }

        this.timeline.addTween(cjs.Tween.get(this.p3).wait(1));

    }).prototype = getMCSymbolPrototype(lib.mai, new cjs.Rectangle(-631.4, -407.3, 983.2, 676.9000000000001), null);


// stage content:
    (lib._05 = function (mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});
		/*
		 // timeline functions:
		 this.frame_0 = function() {
		 var tl = new TimelineMax();
		 var tl2 = new TimelineMax();

		 var time=0.31;
		 var yb=0; // y begin
		 var xb=-10; // x begin
		 var xO=70;// x stop

		 var x5=((xO-xb)/4)*(0)+xb;
		 var x4=((xO-xb)/4)*(1)+xb;
		 var x3=((xO-xb)/4)*(2)+xb;
		 var x2=((xO-xb)/4)*(3)+xb;
		 var x1=((xO-xb)/4)*(4)+xb;


		 tl.set(this.mai, {x:750, y:610});
		 // ariel
		 tl.set(this.mai.ariel, {x:-0, y:-23, scaleX:0.5, scaleY:0.5,alpha:1}, "start");
		 tl.to(this.mai.ariel, 2, {x:-333, y:-23, scaleX:1, scaleY:1,alpha:1 ,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1")}, "start+=0.9" )

		 tl.set(this.mai.ariel.mask, {x:-336, y:-14, alpha:1}, "start");
		 // keng
		 tl.set(this.mai.keng, {x:224, y:50, scaleX:0.58, scaleY:0.58,alpha:1}, "start");
		 tl.to(this.mai.keng, 2, {x:-20, y:-8, scaleX:1, scaleY:1,alpha:1 ,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1")}, "start+=0.7" )

		 // ten

		 tl.set(this.mai.shdw, {x:224, y:220,alpha:0.1}, "start");
		 tl.to(this.mai.shdw ,  2, {x:-20, y:260 ,alpha:0,scaleX:1.6, scaleY:1, ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1")}, "start+=0.7")

		 // s1
		 tl.set(this.mai.p1.mask, {x:-4, y:0, scaleX:0, scaleY:0},"start");
		 tl.to(this.mai.p1.mask,  3.7, {x:-400, y:-90, scaleX:1, scaleY:1,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1")}, "start+=1")

		 // p1
		 tl.set(this.mai.p1, {x:4, y:10, scaleX:0.7, scaleY:0.7}, "start");
		 tl.to(this.mai.p1,  3, {x:-437, y:-190, scaleX:1, scaleY:1,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1")}, "start+=1.1")

		 // s2
		 tl.set(this.mai.p2.mask, {x:-50, y:-65, scaleX:0, scaleY:0,rotation:-84}, "start");
		 tl.to(this.mai.p2.mask,  2, {x:200, y:-333, scaleX:1, scaleY:1,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1")}, "start+=0.9")
		 // p2
		 tl.set(this.mai.p2, {x:-100, y:190, scaleX:0.1, scaleY:1}, "start");
		 tl.to(this.mai.p2,  0.7, {x:200, y:-520, scaleX:0.1, scaleY:1,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1")}, "start+=0.9")


		 // s3
		 tl.set(this.mai.p3.mask, {x:-0, y:100, scaleX:0, scaleY:0}, "start");
		 tl.to(this.mai.p3.mask, 3, {x:-250, y:180, scaleX:1, scaleY:1, ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1")}, "start+=0.7")

		 // p3
		 tl.set(this.mai.p3, {x:-0, y:100, scaleX:0.9, scaleY:0.9}, "start");
		 tl.to(this.mai.p3,  4, {x:-217, y:143, scaleX:1, scaleY:1,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1")}, "start+=0.7")
		 tl2.set(this.mai.p3.pt, {rotation:0, ease:Linear.easeNone}, "start");
		 tl2.to(this.mai.p3.pt ,  160, {rotation:360,repeat:-1 ,yoyo:true}, "start")

		 // ------------ litter---------


		 tl.set(this.mai.letter.letter1, {x:x1, y:yb, alpha:0,}, "start");
		 tl.to(this.mai.letter.letter1 ,  time+0.4, {x:x1, y:yb, alpha:1,ease: CustomEase.create("custom", "M0,0 C0.022,0.068 0.11,0.478 0.246,0.63 0.367,0.765 0.422,0.85 1,1")}, "start+=0.9")

		 tl.set(this.mai.letter.letter2, {x:x2, y:yb, alpha:0}, "start");
		 tl.to(this.mai.letter.letter2 ,  time+0.4, {x:x2, y:yb, alpha:1,ease: CustomEase.create("custom", "M0,0 C0.026,0.136 0.064,0.548 0.2,0.7 0.321,0.835 0.406,0.902 1,1")}, "start+=0.8")
		 tl.to(this.mai.letter.letter2 ,  time+0.3, {alpha:0}, "start+=0.98")

		 tl.set(this.mai.letter.letter3, {x:x3, y:yb, alpha:0}, "start");
		 tl.to(this.mai.letter.letter3 ,  time+0.2, {x:x3, y:yb, alpha:1,ease: CustomEase.create("custom", "M0,0,C0,0.27,0.028,0.626,0.164,0.778,0.285,0.913,0.422,0.974,1,1")}, "start+=0.7")
		 tl.to(this.mai.letter.letter3 ,  time-0.2, {alpha:0}, "start+=0.88")

		 tl.set(this.mai.letter.letter4, {x:x4, y:yb, alpha:0}, "start");
		 tl.to(this.mai.letter.letter4 , time+0.3, {x:x4, y:yb, alpha:1,ease: CustomEase.create("custom", "M0,0,C0,0.27,0.028,0.626,0.164,0.778,0.285,0.913,0.422,0.974,1,1")}, "start+=0.6")
		 tl.to(this.mai.letter.letter4 , time-0.3, {alpha:0}, "start+=0.78")

		 tl.set(this.mai.letter.letter5, {x:x5, y:yb, alpha:1}, "start");
		 tl.to(this.mai.letter.letter5 ,  time, {x:x5, y:yb, alpha:1,ease: CustomEase.create("custom", "M0,0,C0.01,0.406,0,0.708,0.136,0.86,0.257,0.995,0.308,1,1,1")}, "start+=0.4")
		 tl.to(this.mai.letter.letter5 ,  time, {alpha:0}, "start+=0.68")


		 // ------------ litter---------
		 }

		 // actions tween:
		 this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));*/

        // logo_mc
        this.mai = new lib.mai();
        this.mai.name = 'mai';
        this.mai.parent = this;
        this.mai.setTransform(800, 670);

        this.timeline.addTween(cjs.Tween.get(this.mai).wait(1));

    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(426.6, 690.9, 1073.4, 812.1);
// library properties:
    lib.properties = {
        id: 'CF05A2142ADA401E9DA4E5A26203859F',
        width: 1250,
        height: 1250,
        fps: 60,
        color: '#FFFFFF',
        opacity: 1.00,
        manifest: [
            {src: 'images/ariel.png', id: 'ariel'},
            {src: 'images/Bitmap1.png', id: 'Bitmap1'},
            {src: 'images/Bitmap2.png', id: 'Bitmap2'},
            {src: 'images/img_05.jpg', id: 'img_05'},
            {src: 'images/Microphone.png', id: 'Microphone'}
        ],
        preloads: []
    };



// bootstrap callback support:

    (lib.Stage = function (canvas) {
        createjs.Stage.call(this, canvas);
    }).prototype = p = new createjs.Stage();

    p.setAutoPlay = function (autoPlay) {
        this.tickEnabled = autoPlay;
    }
    p.play = function () {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndPlay(this.getTimelinePosition())
    }
    p.stop = function (ms) {
        if (ms) this.seek(ms);
        this.tickEnabled = false;
    }
    p.seek = function (ms) {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000);
    }
    p.getDuration = function () {
        return this.getChildAt(0).totalFrames / lib.properties.fps * 1000;
    }

    p.getTimelinePosition = function () {
        return this.getChildAt(0).currentFrame / lib.properties.fps * 1000;
    }

    an.bootcompsLoaded = an.bootcompsLoaded || [];
    if (!an.bootstrapListeners) {
        an.bootstrapListeners = [];
    }

    an.bootstrapCallback = function (fnCallback) {
        an.bootstrapListeners.push(fnCallback);
        if (an.bootcompsLoaded.length > 0) {
            for (var i = 0; i < an.bootcompsLoaded.length; ++i) {
                fnCallback(an.bootcompsLoaded[i]);
            }
        }
    };

    an.compositions = an.compositions || {};
    an.compositions['CF05A2142ADA401E9DA4E5A26203859F'] = {
        getStage: function () {
            return exportRoot.getStage();
        },
        getLibrary: function () {
            return lib;
        },
        getSpriteSheet: function () {
            return ss;
        },
        getImages: function () {
            return img;
        }
    };

    an.compositionLoaded = function (id) {
        an.bootcompsLoaded.push(id);
        for (var j = 0; j < an.bootstrapListeners.length; j++) {
            an.bootstrapListeners[j](id);
        }
    }

    an.getComposition = function (id) {
        return an.compositions[id];
    }


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});

// export const AdobeAn = AdobeAn;
export const composition = AdobeAn.getComposition('CF05A2142ADA401E9DA4E5A26203859F');